export default __webpack_public_path__ + "static/media/ujama.1e5b67ce.svg";